import React, { useState, useMemo } from 'react';
import HeroSection from '../components/HeroSection';
import Picture from '../components/Picture';
import SEO from '../components/SEO';

const HERO_IMG = '/images/bar-hero.jpg';

const categories = [
  { id: 'blonde', label: 'Blonde', pint: '£5.00', half: '£2.50' },
  { id: 'pale', label: 'Pale', pint: '£5.00', half: '£2.50' },
  { id: 'golden', label: 'Golden', pint: '£5.00', half: '£2.50' },
  { id: 'bitter', label: 'Bitter', pint: '£5.00', half: '£2.50' },
  { id: 'stout', label: 'Stout & Porter', pint: '£5.00', half: '£2.50' },
  { id: 'ipa', label: 'IPA', pint: '£5.00', half: '£2.50' },
  { id: 'pins', label: 'PINs', pint: '£5.00', half: '£2.50' },
  { id: 'lager', label: 'Lager', pint: '£6.00', half: '£3.00' },
  { id: 'cider', label: 'Cider', pint: '£6.00', half: '£3.00' },
];

const beers = {
  blonde: [
    { num: 1, name: 'Farmers Blonde', brewery: 'Bradfield Brewery', abv: '4%', desc: 'Award winning, very pale brilliant blonde beer with citrus and summer fruit aromas. Extremely refreshing and easy drinking.', sponsor: 'AS Ltd - Engineering Consultancy', soldOut: true },
    { num: 2, name: 'Quarantine', brewery: 'Eyam Brewery', abv: '4.5%', desc: 'Classic English blonde ale. Lightly hopped with a background of sweetness for an easy drinking mild flavoured beer.', sponsor: 'Binary Consultancy Limited' },
    { num: 3, name: 'Swedish Blonde', brewery: 'Crafty Keg', abv: '4.3%', desc: 'Lager-like beer — light, clean, and highly refreshing. Crisp malt base balanced by gentle bitterness with subtle herbal and floral notes from Saaz and Tettnanger hops.', sponsor: 'Grundy - Architecture by Design', soldOut: true },
    { num: 4, name: 'Stride', brewery: 'Peak Ales', abv: '4%', desc: 'Named after local landmark Robin Hood\'s Stride. Brewed with Godiva & Harlequin hops and Halcyon malt, bursting with tropical fruit and citrus. Balanced by a smooth biscuity finish.', sponsor: 'Glossop Market Hall' },
    { num: 5, name: 'Stark BA', brewery: 'P-Noot Brew Co', abv: '4.1%', desc: 'Lightly hopped with subtle sweet notes and a delicate citrus aroma.', sponsor: 'Derbyshire Vision' },
    { num: 6, name: 'Jack in the Box', brewery: 'Blackjack Brewery', abv: '4%', desc: 'Bright classic British cask blonde that glints in the light. Hedgerow, marmalade aroma with pithy, earthy citrus notes and a slight caramel malt backbone.', sponsor: 'Glossop Market Hall' },
    { num: 7, name: 'Snow White', brewery: 'Whim Ales', abv: '5%', desc: 'Cloudy, full-bodied Bavarian style wheat beer using coriander. Pale.', sponsor: 'Centre Stage' },
  ],
  pale: [
    { num: 8, name: 'Deepdale', brewery: 'Buxton Brewery', abv: '4%', desc: 'More to this refreshing Pale Ale than meets the eye. Bursting with modern hops yet light, highly drinkable and gluten free.', sponsor: "Harvey Leonard's Wine & Ale", soldOut: true },
    { num: 9, name: 'Galaxy', brewery: 'Chapel Brewin Company', abv: '4.2%', desc: 'Citrus peach and passionfruit flavour pale.', sponsor: 'Hadfield Motors Limited' },
    { num: 10, name: 'Rakau', brewery: 'Crafty Keg', abv: '4%', desc: 'Bright, smooth and full of flavour. Brewed with Rakau hops bringing stone fruit and citrus — think peach, apricot and a hint of lime. Soft bitterness and a crisp finish.', sponsor: 'Roots & Shoots' },
    { num: 11, name: 'Bread and Butter', brewery: 'Vocation Brewery', abv: '3.9%', desc: 'Mild and refreshing citrus notes, a crisp pine finish, and a rounded bitterness. Proves that the simplest of things are often best.', sponsor: 'The Market Cafe Glossop' },
    { num: 12, name: 'New Mills Madness', brewery: 'Thornsett Brewery', abv: '5%', desc: 'Devilishly sharp pale ale with a light malty base and finished with citrusy and earthy hops.', sponsor: 'Foxx Building Services Group' },
    { num: 13, name: 'Yellow Peak', brewery: 'Torrside Brewery', abv: '4%', desc: 'American style light-bodied pale, brewed with Amarillo & Summit & dry-hopped with Mosaic like a proper craft beer.', sponsor: 'Progressive Solicitors' },
    { num: 14, name: 'Tiger Rut', brewery: 'Millstone Brewery', abv: '4%', desc: 'Very pale and hoppy ale. Using Chinook hops, a mellow bitter makes way for a distinctive citrus/grapefruit aroma.' },
    { num: 15, name: 'Citra', brewery: 'Millstone Brewery', abv: '4%', desc: 'Light and refreshing pale ale. Brewed with Citra hops; a light bitterness makes way for a forward yet balanced citrus flavour and aroma.', sponsor: 'Glossop Gasworks', soldOut: true },
    { num: 18, name: 'Irk Street', brewery: 'Blackjack Brewery', abv: '3.4%', desc: 'Pale golden ale served strikingly bright. Clean citrus fruit & slight honeyed malt notes. Quenching citrus hop flavour, medium bodied & extremely balanced.', sponsor: 'Karsons Lettings' },
  ],
  golden: [
    { num: 19, name: 'Farmers Ale', brewery: 'Bradfield Brewery', abv: '4%', desc: 'Traditional copper coloured malt ale using the finest English hops to produce both a floral and smooth aroma with a sharp finish.', sponsor: 'McNabarbers' },
    { num: 20, name: 'Chatsworth Gold', brewery: 'Peak Ales', abv: '4.6%', desc: 'Golden beer made with honey from the Chatsworth Estate. Delicate sweetness well balanced with bitterness from Goldings and Fuggles hops.', soldOut: true },
    { num: 21, name: 'Apex', brewery: 'P-Noot Brew Co', abv: '3.8%', desc: 'Soft fruity English golden ale. Full bodied with balanced bitterness.', sponsor: 'Surge Building Services' },
  ],
  bitter: [
    { num: 22, name: 'Strange Ways', brewery: 'Green Mill Brewery', abv: '3.9%', desc: 'A Boddingtons style bitter from Broadbottom.', soldOut: true },
    { num: 23, name: 'Gold', brewery: 'Green Mill Brewery', abv: '3.9%', desc: 'A quaffable session English Bitter.' },
  ],
  stout: [
    { num: 24, name: 'Farmers Stout', brewery: 'Bradfield Brewery', abv: '4.5%', desc: 'Dark enriched vanilla seasoned, black & white stout. Balanced by roasted malts and flaked oats with a subtle bitter hop character and slightly sweet finish.', sponsor: 'Bar 2 Tap Bar' },
    { num: 25, name: 'Beep Beep Corner', brewery: 'Thornsett Brewery', abv: '5%', desc: 'Because you can\'t bloody see, it\'s better when it\'s dark. A dark, flavourful English Stout.', sponsor: 'Britannia Taxis Glossop Limited' },
  ],
  ipa: [
    { num: 16, name: 'Flower Power', brewery: 'Whim Ales', abv: '5%', desc: 'Huge hop nose. Warmth of malt gives to big citrus grapefruit and slightly herby hop flavours. Develops into a complex lasting finish. Dry and packed full of complex flavours.', sponsor: 'Norris Master Florists' },
    { num: 17, name: 'Ring of Roses', brewery: 'Eyam Brewery', abv: '5%', desc: 'Pale base with a noticeable bittering hop addition, dry hopped to add a complex aroma from a United Nations blend of hops.', sponsor: 'Foxx Building Services Group' },
  ],
  pins: [
    { num: 26, name: 'Stanage', brewery: 'Intrepid Brewery', abv: '4.5%', desc: 'Dry Stout. A classic dry stout from the family-run Intrepid Brewing Company in Hope, Derbyshire. Silky-smooth body with rich roasted malt, cocoa and coffee notes, rounded out by a dry, hoppy finish.', sponsor: 'Westwood Aparthotel' },
    { num: 27, name: 'Ban English', brewery: 'Intrepid Brewery', abv: '4.1%', desc: 'Session IPA. Moreish and refreshing, hopped with UK Cascade and Harlequin T45 layered on a crisp oaty body. Shows what UK hops can do!', sponsor: 'The Star', soldOut: true },
    { num: 28, name: 'Solito', brewery: 'Intrepid Brewery', abv: '4%', desc: 'Pale Ale. Bright, fresh, and zesty session beer brewed with a blend of American hops that provide a fruity, verdant aroma.', sponsor: 'GlossFest 2027', soldOut: true },
    { num: 29, name: 'Röke', brewery: 'Intrepid Brewery', abv: '4.8%', desc: 'English Pale Ale. Peachy, fruit-forward flavour profile featuring Citra and Idaho 7 hops. Balanced and refreshing with a clean, smooth, hop-forward finish.', sponsor: 'Glossop Heritage Weekend' },
  ],
  lager: [
    { num: 30, name: 'Cavern Lager', brewery: 'Buxton Brewery', abv: '4.2%', desc: 'Gluten-Free Helles-style lager. Clean, crisp, and refreshing with a delicate malty backbone, subtle fruity notes, and a gentle European hop bitterness. Unfiltered.', sponsor: 'Glossop & District Round Table 916' },
  ],
  cider: [
    { num: 31, name: "What's The Plan", brewery: 'High Peak Cider', abv: '5.9%', desc: 'Wild fermented dry, crisp cider using only apples grown in the High Peak. Bright, sharp, tangy and low in tannins.', style: 'Dry', sponsor: 'Extinguisher Hire Ltd' },
    { num: 32, name: 'There Is No Planet B', brewery: 'High Peak Cider', abv: '4.7%', desc: 'Wild fermented cider, blended to an easy drinking medium dry. Nicely rounded, soft session cider.', style: 'Medium', sponsor: 'Extinguisher Hire Ltd' },
    { num: 33, name: 'Elder', brewery: 'High Peak Cider', abv: '4%', desc: 'Made by foraging elderflowers from local trees. Flowers infused into a cordial, blended with wild fermented dry cider and apple juice. Sherbet-sweet profile.', style: 'Fruit', sponsor: 'Extinguisher Hire Ltd' },
    { num: 34, name: "Crackin' Pear & Elder", brewery: 'Red Bank Cider', abv: '4%', desc: 'Medium-sweet, hand-crafted pear cider (perry). Blends freshly pressed English pears with elderflower. Award-winning.', style: 'Fruit', sponsor: 'High Peak Borough Council' },
    { num: 35, name: "Crackin' Pear", brewery: 'Red Bank Cider', abv: '4%', desc: 'Award winning 5 Star pear cider. Made simply with pears — NEVER from water. Refreshingly lower in sugar. The original English pear cider!', style: 'Fruit', sponsor: 'High Peak Borough Council', soldOut: true },
    { num: 36, name: 'Apple & Mango', brewery: 'Red Bank Cider', abv: '4%', desc: 'Medium Dry Cider not from concentrate, lower in sugar. Amazing, so refreshing, delicious!', style: 'Fruit', sponsor: 'High Peak Borough Council' },
    { num: 37, name: 'Cherry Cider', brewery: 'Red Bank Cider', abv: '4%', desc: 'Award winning Autumn Orchard traditional cider with Morello cherry and subtle Amaretto almonds. Delightfully refreshing medium cider.', style: 'Fruit', sponsor: 'High Peak Borough Council' },
    { num: 38, name: 'Wild Blueberry', brewery: 'Red Bank Cider', abv: '4%', desc: 'CAMRA approved fruit cider. Crafted from "Not from Concentrate" with wild-grown whole blueberries from organic forests. Not too sweet!', style: 'Fruit', sponsor: 'High Peak Borough Council' },
    { num: 39, name: 'Strawberry', brewery: 'Red Bank Cider', abv: '4%', desc: 'CAMRA approved fruit cider. Crafted with wild-grown strawberries from sustainably managed forests. Hand crafted and not too sweet!', style: 'Fruit', sponsor: 'High Peak Borough Council' },
    { num: 40, name: 'Raspberry', brewery: 'Red Bank Cider', abv: '4%', desc: 'CAMRA approved fruit cider. Crafted with wild-grown raspberries from sustainably managed forests. Hand crafted and not too sweet!', style: 'Fruit', sponsor: 'High Peak Borough Council' },
  ],
};

const breweries = [
  { name: 'Bradfield Brewery', location: 'Sheffield', logo: '/images/bradfield_brew.png' },
  { name: 'Eyam Brewery', location: 'Eyam', logo: '/images/eyam_brew.png' },
  { name: 'Peak Ales', location: 'Bakewell', logo: '/images/peak_ales.png' },
  { name: 'Buxton Brewery', location: 'Buxton', logo: '/images/buxton_brew.jpg' },
  { name: 'Blackjack Brewery', location: 'Manchester', logo: '/images/black_jack_brew.jpg' },
  { name: 'Whim Ales', location: 'Hartington', logo: '/images/whim_ales.png' },
  { name: 'Millstone Brewery', location: 'Mossley', logo: '/images/millstone_brew.jpg' },
  { name: 'Torrside Brewery', location: 'New Mills', logo: '/images/torrside_brew.jpg' },
  { name: 'Vocation Brewery', location: 'Hebden Bridge', logo: '/images/vocation_brew.jpg' },
  { name: 'Green Mill Brewery', location: 'Broadbottom', logo: '/images/green_mill.png' },
  { name: 'Intrepid Brewery', location: 'Hope Valley', logo: '/images/intrepid_brew.jpg' },
  { name: 'High Peak Cider', location: 'High Peak', logo: '/images/hp_cider.png' },
  { name: 'Red Bank Cider', location: 'Lancashire', logo: '/images/red-bank-new.jpg' },
  { name: 'Thornsett Brewery', location: 'New Mills', logo: '/images/thornsett_brew.png' },
  { name: 'Chapel Brewin Company', location: 'Chapel-en-le-Frith', logo: '/images/chapel_brew.png' },
  { name: 'P-Noot Brew Co', location: 'Derbyshire', logo: '/images/p_noot_brew.jpg' },
  { name: 'Crafty Keg', location: 'Tameside', logo: '/images/crafty_keg.jpg' },
];

const cocktailCategories = [
  { id: 'cocktails', label: 'Cocktails' },
  { id: 'spritz', label: 'Spritz' },
  { id: 'wine', label: 'Wine' },
  { id: 'prosecco', label: 'Prosecco' },
  { id: 'spirits', label: 'Spirits' },
  { id: 'non-alcoholic', label: 'Non-Alcoholic' },
  { id: 'soft-drinks', label: 'Soft Drinks' },
];

// Image mapping used only by the printable PDF. We keep it next to the data
// so adding/removing a drink is a one-line change. Paths are absolute so the
// PDF generator can fetch them via the public site URL.
const COCKTAIL_IMG = {
  'Rum Punch': '/images/cocktails/rum-punch.jpg',
  'Rose Sangria': '/images/cocktails/sangria.jpg',
  'Pimms': '/images/cocktails/pimms.jpg',
  'Mojito / Strawberry Mojito': '/images/cocktails/mojito.jpg',
  'Passionfruit Martini': '/images/cocktails/passionfruit-martini.jpg',
  'Dark & Stormy': '/images/cocktails/dark-and-stormy.jpg',
  'Tom Collins': '/images/cocktails/tom-collins.jpg',
  'Aperol Spritz': '/images/cocktails/aperol-spritz.jpg',
  'Limoncello Spritz': '/images/cocktails/limoncello.jpg',
  'Hugo Spritz': '/images/cocktails/hugo-spritz.jpg',
  'Campari Spritz': '/images/cocktails/campari-spritz.jpg',
  'Virgin Mojito / Strawberry': '/images/cocktails/virgin-mojito.jpg',
  'Virgin Aperol Spritz': '/images/cocktails/aperol-spritz.jpg',
  'Virgin Limoncello Spritz': '/images/cocktails/limoncello.jpg',
};

const cocktails = {
  cocktails: [
    { name: 'Rum Punch', desc: 'Rum punch', price: '£8.00 glass', price2: 'Pitcher £26.00 + £5.00 refundable deposit' },
    { name: 'Rose Sangria', desc: 'Rose sangria', price: '£8.00 glass', price2: 'Pitcher £26.00 + £5.00 refundable deposit' },
    { name: 'Pimms', desc: "Classic Pimm's", price: '£8.00 glass', price2: 'Pitcher £26.00 + £5.00 refundable deposit' },
    { name: 'Mojito / Strawberry Mojito', desc: 'White rum, lime juice, mint, soda water (strawberry puree)', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Passionfruit Martini', desc: 'Vanilla vodka, passion fruit liqueur, lime puree, prosecco', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Dark & Stormy', desc: 'Dark rum, lime, ginger beer', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Tom Collins', desc: 'Gin, lime, soda water', price: '£8.00 each', price2: '2 for £15.00' },
  ],
  spritz: [
    { name: 'Aperol Spritz', desc: 'Aperol, prosecco, soda water', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Limoncello Spritz', desc: 'Limoncello, prosecco, soda water', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Hugo Spritz', desc: 'St Germain elderflower, prosecco, soda water', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Campari Spritz', desc: 'Campari, prosecco, soda water', price: '£8.00 each', price2: '2 for £15.00' },
  ],
  wine: [
    { name: 'Pinot Grigio', desc: 'White wine', price: '£6.00 medium', price2: '£8.00 large' },
    { name: 'Sauvignon Blanc', desc: 'White wine', price: '£6.00 medium', price2: '£8.00 large' },
    { name: 'Chardonnay', desc: 'White wine', price: '£6.00 medium', price2: '£8.00 large' },
    { name: 'Malbec / Rioja', desc: 'Red wine', price: '£6.00 medium', price2: '£8.00 large' },
    { name: 'Rose', desc: 'Rose wine', price: '£6.00 medium', price2: '£8.00 large' },
  ],
  prosecco: [
    { name: 'Prosecco — White', desc: 'Sparkling white prosecco', price: '£6.00 medium', price2: '£8.00 large' },
    { name: 'Prosecco — Rose', desc: 'Sparkling rose prosecco', price: '£6.00 medium', price2: '£8.00 large' },
  ],
  'non-alcoholic': [
    { name: 'Virgin Mojito / Strawberry', desc: "Lime and mint, soda water (strawberry puree), Captain Morgan's 0% Rum", price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Virgin Aperol Spritz', desc: 'Non-alcoholic Aperol Spritz', price: '£8.00 each', price2: '2 for £15.00' },
    { name: 'Virgin Limoncello Spritz', desc: 'Non-alcoholic Limoncello Spritz', price: '£8.00 each', price2: '2 for £15.00' },
  ],
  spirits: [
    { name: 'Spirit & Mixer (Single 25ml)', desc: 'Bombay Sapphire, Gordons, Gordons Pink Gin, Smirnoff Vodka, Absolute Vanilla Vodka, Captain Morgans Spiced Rum, Bacardi White Rum, Jack Daniels, Tequila, Kahlua, 0% Gin, 0% Rum', price: '£6.00 single' },
    { name: 'Spirit & Mixer (Double 50ml)', desc: 'Bombay Sapphire, Gordons, Gordons Pink Gin, Smirnoff Vodka, Absolute Vanilla Vodka, Captain Morgans Spiced Rum, Bacardi White Rum, Jack Daniels, Tequila, Kahlua, 0% Gin, 0% Rum', price: '£8.00 double' },
    { name: 'Mixers Available', desc: 'Coke Zero, Lemonade, 7Up, Tonic, Slimline Tonic, Ginger Ale, Orange Juice, Cranberry Juice, Pineapple Juice, Soda Water, Lime Cordial', price: 'Included' },
  ],
  'soft-drinks': [
    { name: 'Coke Zero', desc: 'Soft drink', price: '£2.00' },
    { name: 'Lemonade', desc: 'Soft drink', price: '£2.00' },
    { name: '7Up', desc: 'Soft drink', price: '£2.00' },
    { name: 'Orange Juice', desc: 'Soft drink', price: '£2.00' },
    { name: 'Cranberry Juice', desc: 'Soft drink', price: '£2.00' },
    { name: 'Pineapple Juice', desc: 'Soft drink', price: '£2.00' },
    { name: 'Bottle of Water', desc: 'Still water', price: '£1.50' },
  ],
};

const sponsors = [
  { name: 'MBC Building Contractors NW', desc: 'Main Sponsor — Supporting the Round Table Bar', url: 'https://www.mbcbuilding.co.uk/', mainSponsor: true },
  { name: 'Binary Consultancy Limited', desc: 'Supporting Quarantine by Eyam Brewery', url: 'https://www.bincon.net/' },
  { name: 'Torside Building Consultants Ltd', desc: 'Supporting the Round Table Bar', url: 'https://www.torside.co.uk' },
  { name: 'Rhodes & Partners, Consulting Structural Engineers', desc: 'Supporting the Cocktail Bar', url: 'https://www.rhodesandpartners.co.uk/' },
  { name: 'Karsons Lettings', desc: 'Supporting Irk Street by Blackjack Brew Co.', url: 'https://www.karsonslettings.com/' },
  { name: 'Foxx Building Services Group', desc: 'Supporting New Mills Madness by Thornsett Brewery', url: 'http://foxxgroup.co.uk/' },
  { name: 'Foxx Building Services Group', desc: 'Supporting Ring of Roses by Eyam Brewery', key: 'foxx2', url: 'http://foxxgroup.co.uk/' },
  { name: 'Westwood Aparthotel', desc: 'Supporting Stanage by Intrepid Brewery', url: 'https://www.westwoodaparthotel.co.uk/' },
  { name: 'The Star', desc: 'Supporting Ban English by Intrepid Brewery', url: 'https://www.facebook.com/thestarinnglossop/?locale=en_GB' },
  { name: 'GlossFest 2027', desc: 'Supporting Solito by Intrepid Brewery', url: 'https://www.glossfest.com/' },
  { name: 'Glossop Heritage Weekend', desc: 'Supporting Röke by Intrepid Brewery', url: 'https://glossopheritageweekend.org/' },
  { name: 'Glossop Market Hall', desc: 'Supporting Stride by Peak Ales', url: 'https://www.glossopmarkethall.co.uk/' },
  { name: 'Glossop Market Hall', desc: 'Supporting Jack in the Box by Blackjack Brew Co.', key: 'gmh2', url: 'https://www.glossopmarkethall.co.uk/' },
  { name: 'McNabarbers', desc: 'Supporting Farmers Ale by Bradfield Brewery', url: 'https://www.instagram.com/mcnabarbers/' },
  { name: 'Surge Building Services', desc: 'Supporting Apex EGA by P-Noot Brew Co.', url: 'https://www.surgebuildingservices.com/' },
  { name: 'Bar 2 Tap Bar', desc: 'Supporting Farmers Stout by Bradfield Brewery', url: 'https://www.facebook.com/bar2glossop/?locale=en_GB' },
  { name: 'Britannia Taxis Glossop Limited', desc: 'Supporting Beep Beep Corner by Thornsett Brewery', url: 'https://www.facebook.com/britanniataxis.glossop/' },
  { name: 'Glossop & District Round Table 916', desc: 'Supporting Cavern Lager by Buxton Brewery', url: 'https://www.glossoproundtable.org/' },
  { name: 'Norris Master Florists', desc: 'Supporting Flower Power by Whim Ales', url: 'https://www.norris.store/' },
  { name: 'Glossop Gasworks', desc: 'Supporting Citra by Millstone Brewery', url: 'https://www.glossopgasworks.co.uk/' },
  { name: 'The Corner Cupboard', desc: 'Supporting Tiger Rut by Millstone Brewery', url: 'https://www.facebook.com/cornercupboardglossop/?locale=en_GB' },
  { name: 'Progressive Solicitors', desc: 'Supporting Yellow Peak by Torrside Brewery', url: 'https://progressivesolicitors.co.uk/' },
  { name: 'Roots & Shoots', desc: 'Supporting Rakau by Crafty Keg', url: 'https://www.rootsandshootsmanchester.com/' },
  { name: 'The Market Cafe Glossop', desc: 'Supporting Bread and Butter by Vocation', url: 'https://www.facebook.com/GlossopMarket/' },
  { name: 'Hadfield Motors Limited', desc: 'Supporting Galaxy by Chapel Brewing Company', url: 'https://www.facebook.com/hadfieldmotorsltd/?locale=en_GB' },
  { name: "Harvey Leonard's Wine & Ale", desc: 'Supporting Deepdale by Buxton Brewery', url: 'https://www.harvey-leonard.com/' },
  { name: 'Centre Stage', desc: 'Supporting Snow White by Whim Ales', url: 'https://www.centrestage-dance.com/' },
  { name: 'Derbyshire Vision', desc: 'Supporting Stark BA by P-Noot Brew Co.', url: 'https://www.derbyshirevision.com/' },
  { name: 'Grundy - Architecture by Design', desc: 'Supporting Swedish Blonde Sterling by Crafty Keg', url: 'https://grundyarchitecture.co.uk/our-projects/' },
  { name: 'AS Ltd - Engineering Consultancy', desc: 'Supporting Farmers Blonde by Bradfield Brewery' },
  { name: 'High Peak Borough Council', desc: 'Supporting all Red Bank Ciders', url: 'https://www.highpeak.gov.uk/' },
  { name: 'Extinguisher Hire Ltd', desc: 'Supporting all High Peak Ciders', url: 'https://www.extinguisher-hire.co.uk/' },
];

// Pre-computed at module load — keeps JSX render path cheap (avoids re-filtering on every render).
const mainSponsors = sponsors.filter((s) => s.mainSponsor);
const otherSponsors = sponsors.filter((s) => !s.mainSponsor);

const sponsorUrls = {
  'MBC Building Contractors NW': 'https://www.mbcbuilding.co.uk/',
  'Binary Consultancy Limited': 'https://www.bincon.net/',
  'Rhodes & Partners': 'https://www.rhodesandpartners.co.uk/',
  'Karsons Lettings': 'https://www.karsonslettings.com/',
  'Foxx Building Services Group': 'http://foxxgroup.co.uk/',
  'Westwood Aparthotel': 'https://www.westwoodaparthotel.co.uk/',
  'The Star': 'https://www.facebook.com/thestarinnglossop/?locale=en_GB',
  'GlossFest 2027': 'https://www.glossfest.com/',
  'Glossop Heritage Weekend': 'https://glossopheritageweekend.org/',
  'Glossop Market Hall': 'https://www.glossopmarkethall.co.uk/',
  'McNabarbers': 'https://www.instagram.com/mcnabarbers/',
  'Surge Building Services': 'https://www.surgebuildingservices.com/',
  'Bar 2 Tap Bar': 'https://www.facebook.com/bar2glossop/?locale=en_GB',
  'Britannia Taxis Glossop Limited': 'https://www.facebook.com/britanniataxis.glossop/',
  'Glossop & District Round Table 916': 'https://www.glossoproundtable.org/',
  'Norris Master Florists': 'https://www.norris.store/',
  'Glossop Gasworks': 'https://www.glossopgasworks.co.uk/',
  'The Corner Cupboard': 'https://www.facebook.com/cornercupboardglossop/?locale=en_GB',
  'Progressive Solicitors': 'https://progressivesolicitors.co.uk/',
  'Roots & Shoots': 'https://www.rootsandshootsmanchester.com/',
  'The Market Cafe Glossop': 'https://www.facebook.com/GlossopMarket/',
  'Hadfield Motors Limited': 'https://www.facebook.com/hadfieldmotorsltd/?locale=en_GB',
  "Harvey Leonard's Wine & Ale": 'https://www.harvey-leonard.com/',
  'Centre Stage': 'https://www.centrestage-dance.com/',
  'Derbyshire Vision': 'https://www.derbyshirevision.com/',
  'Grundy - Architecture by Design': 'https://grundyarchitecture.co.uk/our-projects/',
  'AS Ltd - Engineering Consultancy': null,
  'High Peak Borough Council': 'https://www.highpeak.gov.uk/',
  'Extinguisher Hire Ltd': 'https://www.extinguisher-hire.co.uk/',
};

// --- Printable PDF menu --------------------------------------------------
// Lazy-loaded so the @react-pdf/renderer chunk (~150 KB) only downloads when
// someone clicks the "Download printable menu" button.
function buildPdfSections(absoluteUrl) {
  const toAbs = (p) => (p ? `${absoluteUrl}${p}` : null);
  const map = (category) =>
    cocktails[category].map((d) => ({
      name: d.name,
      desc: d.desc,
      price: d.glass ? d.glass : (d.medium ? d.medium : (d.single ? d.single : (d.bottle || ''))),
      price2: d.pitcher
        ? `or ${d.pitcher} pitcher`
        : (d.large ? `${d.large} large` : (d.double ? `${d.double} dbl` : '')),
      img: toAbs(COCKTAIL_IMG[d.name]),
    }));
  return {
    cocktails: map('cocktails'),
    spritz: map('spritz'),
    wine: map('wine'),
    prosecco: map('prosecco'),
    spirits: map('spirits'),
    'non-alcoholic': map('non-alcoholic'),
    'soft-drinks': map('soft-drinks'),
  };
}

function PrintableMenuButton() {
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleClick = async () => {
    setBusy(true);
    setError('');
    try {
      const { downloadCocktailMenu } = await import('../components/CocktailMenuPdf');
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const qrTarget = `${origin}/charity-bar#cocktails`;
      const qrSrc = `${origin}/api/qr?url=${encodeURIComponent(qrTarget)}&size=320`;
      await downloadCocktailMenu({
        logoSrc: `${origin}/images/glossop_rt_logo.png`,
        qrSrc,
        qrTarget,
        sections: buildPdfSections(origin),
        glassPrice: '£5.00',
        pitcherPrice: '£15.00',
        withImages: true,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Menu PDF failed:', e);
      setError('Sorry — couldn\u2019t build the PDF just now. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-6 flex flex-col items-center gap-2" data-testid="printable-menu-wrap">
      <button
        type="button"
        onClick={handleClick}
        disabled={busy}
        data-testid="printable-menu-button"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#0A0A0A] hover:bg-[#27272A] disabled:opacity-60 text-white text-xs font-bold uppercase tracking-wider transition-colors"
      >
        {busy ? 'Building PDF…' : '↓ Download printable cocktail menu'}
      </button>
      <p className="text-[11px] text-[#71717A] max-w-md">
        A4 PDF with 7&nbsp;mm safe margins, ready for the printer.
      </p>
      {error && (
        <p data-testid="printable-menu-error" className="text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}


function BeerCard({ beer }) {
  // Two mutually-exclusive states a beer can be in:
  //  - soldOut: visible diagonal "Sold Out" stamp + reduced opacity.
  //  - availableFrom: visible "Coming Sat 30 May" stamp so customers know
  //    it's pre-announced but not yet pouring.
  const unavailable = beer.soldOut || beer.availableFrom;
  return (
    <div className={`p-5 bg-white border transition-colors relative overflow-hidden ${unavailable ? 'border-[#F0A500]/40 opacity-80' : 'border-zinc-200 hover:border-[#F0A500]'} ${beer.soldOut ? 'opacity-75 border-red-300' : ''}`}>
      {beer.soldOut && (
        <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
          <span className="text-4xl font-black text-red-600 uppercase tracking-wider -rotate-12">
            Sold Out
          </span>
        </div>
      )}
      {!beer.soldOut && beer.availableFrom && (
        <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none px-4">
          <span className="text-center bg-[#F0A500]/95 text-[#0A0A0A] uppercase font-black tracking-wider -rotate-6 shadow-md py-2 px-4 border-2 border-[#0A0A0A]/10">
            <span className="block text-[10px] tracking-[0.2em]">On from</span>
            <span className="block text-lg leading-tight">{beer.availableFrom}</span>
          </span>
        </div>
      )}
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-start gap-2">
          {beer.num && (
            <span className="shrink-0 w-7 h-7 flex items-center justify-center bg-[#0A0A0A] text-white text-xs font-bold">
              {beer.num}
            </span>
          )}
          <h3 className="text-base font-bold text-[#0A0A0A]">{beer.name}</h3>
        </div>
        <span className="shrink-0 text-xs font-bold bg-[#F0A500]/10 text-[#F0A500] px-2 py-1">
          {beer.abv}
        </span>
      </div>
      <p className="text-xs font-semibold text-[#F0A500] uppercase tracking-wide mb-2">
        {beer.brewery} {beer.style && `\u2022 ${beer.style}`}
      </p>
      <p className="text-sm text-[#52525B] leading-relaxed">{beer.desc}</p>
      {beer.sponsor && (
        <p className="text-xs text-[#52525B] italic mt-2">Sponsored by {beer.sponsor}</p>
      )}
    </div>
  );
}

function CocktailCard({ drink }) {
  return (
    <div className="p-5 bg-white border border-zinc-200 hover:border-[#F0A500] transition-colors">
      <div className="flex items-start justify-between gap-3 mb-2">
        <h3 className="text-base font-bold text-[#0A0A0A]">{drink.name}</h3>
        <span className="shrink-0 text-xs font-bold bg-[#F0A500]/10 text-[#F0A500] px-2 py-1 whitespace-nowrap">
          {drink.price}
        </span>
      </div>
      <p className="text-sm text-[#52525B] leading-relaxed mb-2">{drink.desc}</p>
      {drink.price2 && (
        <p className="text-xs font-semibold text-[#F0A500]">{drink.price2}</p>
      )}
    </div>
  );
}

export default function CharityBarBackupPage() {
  const [activeCategory, setActiveCategory] = useState('blonde');
  const [activeCocktailCategory, setActiveCocktailCategory] = useState('cocktails');

  const activePrice = useMemo(() => categories.find(c => c.id === activeCategory), [activeCategory]);

  return (
    <div data-testid="round-table-bar-backup-page">
      <SEO
        title="Round Table Bar — Backup Menu"
        description="Backup / large-event Round Table Bar menu (not linked from the public site)."
        path="/round-table-bar-backup"
        noIndex
      />
      <HeroSection
        image={HERO_IMG}
        title="Round Table Bar"
        subtitle="Run by unpaid volunteers from Round Table and the local community"
        fullHeight={false}
      />

      {/* Intro */}
      <section className="py-12 bg-[#F4F4F5]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-base text-[#52525B] leading-relaxed mb-6">
            The Round Table Bar is staffed entirely by unpaid volunteers from Glossop & District Round Table and the local community. All proceeds go back into running Glossop Heritage Weekend 2028.
          </p>
          <div className="inline-flex flex-wrap justify-center gap-4">
            <div className="bg-white px-5 py-3 border border-zinc-200">
              <p className="text-xs font-bold uppercase tracking-wide text-[#F0A500] mb-1">Ales & Stout</p>
              <p className="text-sm text-[#0A0A0A] font-semibold">£5.00 pint / £2.50 half</p>
            </div>
            <div className="bg-white px-5 py-3 border border-zinc-200">
              <p className="text-xs font-bold uppercase tracking-wide text-[#F0A500] mb-1">Lager & Cider</p>
              <p className="text-sm text-[#0A0A0A] font-semibold">£6.00 pint / £3.00 half</p>
            </div>
            <div className="bg-white px-5 py-3 border border-zinc-200">
              <p className="text-xs font-bold uppercase tracking-wide text-[#F0A500] mb-1">Glasses</p>
              <p className="text-sm text-[#0A0A0A] font-semibold">£1.00 each (non-refundable)</p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Menu</span>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0A0A0A]">
              Real Ales, Craft Beer &amp; Cider
            </h2>
            <p className="text-base text-[#52525B] mt-3 max-w-2xl mx-auto">
              Over 30 real ales, craft beers and ciders from local breweries across the Peak District and beyond.
            </p>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {categories.map((cat) => (
              <button
                key={cat.id}
                data-testid={`tab-${cat.id}`}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 text-sm font-bold uppercase tracking-wide transition-all
                  ${activeCategory === cat.id
                    ? 'bg-[#F0A500] text-[#0A0A0A]'
                    : 'bg-[#F4F4F5] text-[#52525B] hover:bg-[#F0A500]/10 hover:text-[#F0A500]'
                  }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Active category price */}
          <div className="text-center mb-10">
            <p className="text-sm text-[#52525B]">
              <span className="font-bold text-[#0A0A0A]">{activePrice?.pint}</span> pint &nbsp;/&nbsp; <span className="font-bold text-[#0A0A0A]">{activePrice?.half}</span> half
            </p>
            {activeCategory === 'pins' && (
              <p
                data-testid="pins-explainer"
                className="text-xs text-[#71717A] max-w-md mx-auto mt-3 italic leading-relaxed"
              >
                A PIN is a smaller 4.5-gallon cask &mdash; perfect for unique, limited-run beers from Intrepid Brewery.
              </p>
            )}
          </div>

          {/* Beer Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {beers[activeCategory]?.map((beer) => (
              <BeerCard key={beer.name} beer={beer} />
            ))}
          </div>
        </div>
      </section>

      {/* Cocktails & Spirits */}
      <section id="cocktails" data-testid="bar-cocktails" className="py-16 sm:py-24 bg-[#F4F4F5]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Cocktail Menu</span>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0A0A0A]">
              Cocktails, Spritz &amp; Spirits
            </h2>
            <p className="text-base text-[#52525B] mt-3 max-w-2xl mx-auto">
              By the glass or pitcher (adults only). Non-alcoholic options available.
            </p>

            <PrintableMenuButton />
          </div>

          {/* Cocktail Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {cocktailCategories.map((cat) => (
              <button
                key={cat.id}
                data-testid={`cocktail-tab-${cat.id}`}
                onClick={() => setActiveCocktailCategory(cat.id)}
                className={`px-4 py-2 text-sm font-bold uppercase tracking-wide transition-all
                  ${activeCocktailCategory === cat.id
                    ? 'bg-[#F0A500] text-[#0A0A0A]'
                    : 'bg-white text-[#52525B] hover:bg-[#F0A500]/10 hover:text-[#F0A500]'
                  }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Cocktail Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {cocktails[activeCocktailCategory]?.map((drink) => (
              <CocktailCard key={drink.name} drink={drink} />
            ))}
          </div>
        </div>
      </section>

      {/* Breweries */}
      <section data-testid="bar-breweries" className="py-16 sm:py-24 bg-[#F4F4F5]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Featuring</span>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
              Breweries &amp; Cider Makers
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {breweries.slice(0, 12).map((brewery) => (
              <div
                key={brewery.name}
                className="flex flex-col items-center justify-center p-4 bg-white border border-zinc-200 aspect-square"
              >
                {brewery.logo ? (
                  <Picture
                    src={brewery.logo}
                    alt={brewery.name}
                    className="w-16 h-16 object-contain mb-3"
                  />
                ) : (
                  <div className="w-16 h-16 bg-[#F0A500]/10 flex items-center justify-center mb-3">
                    <span className="text-lg font-black text-[#F0A500]">{brewery.name.charAt(0)}</span>
                  </div>
                )}
                <p className="text-xs font-bold text-[#0A0A0A] text-center leading-tight">{brewery.name}</p>
                <p className="text-[10px] text-[#52525B] text-center mt-1">{brewery.location}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            {breweries.slice(12).map((brewery) => (
              <div
                key={brewery.name}
                className="flex flex-col items-center justify-center p-4 bg-white border border-zinc-200 aspect-square w-[calc(50%-8px)] sm:w-[calc(33.333%-11px)] md:w-[calc(25%-12px)] lg:w-[calc(16.666%-14px)]"
              >
                {brewery.logo ? (
                  <Picture
                    src={brewery.logo}
                    alt={brewery.name}
                    className="w-16 h-16 object-contain mb-3"
                  />
                ) : (
                  <div className="w-16 h-16 bg-[#F0A500]/10 flex items-center justify-center mb-3">
                    <span className="text-lg font-black text-[#F0A500]">{brewery.name.charAt(0)}</span>
                  </div>
                )}
                <p className="text-xs font-bold text-[#0A0A0A] text-center leading-tight">{brewery.name}</p>
                <p className="text-[10px] text-[#52525B] text-center mt-1">{brewery.location}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sponsors */}
      <section data-testid="bar-sponsors" className="py-16 sm:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Thank You</span>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
              Sponsors
            </h2>
            <p className="text-base text-[#52525B] mt-3">
              Thank you to our sponsors for their generous support.
            </p>
          </div>
          {/* Main Sponsor */}
          {mainSponsors.map((sponsor) => (
            <div
              key={sponsor.name}
              className="flex flex-col items-center justify-center p-8 bg-[#F4F4F5] border-2 border-[#F0A500] mb-6"
            >
              <div className="w-14 h-14 bg-[#F0A500]/10 flex items-center justify-center mb-3">
                <span className="text-xl font-black text-[#F0A500]">
                  {sponsor.name.charAt(0)}
                </span>
              </div>
              <span className="text-[10px] uppercase tracking-[0.15em] font-bold text-[#F0A500] mb-2">Main Sponsor</span>
              <a href={sponsor.url} target="_blank" rel="noopener noreferrer" className="text-lg font-bold text-[#0A0A0A] text-center leading-tight hover:text-[#F0A500] transition-colors">
                {sponsor.name}
              </a>
              <p className="text-sm text-[#52525B] text-center mt-2 leading-relaxed">{sponsor.desc}</p>
            </div>
          ))}

          {/* Other Sponsors */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {otherSponsors.map((sponsor) => (
              <div
                key={sponsor.key || sponsor.name}
                className="flex flex-col items-center justify-center p-5 bg-[#F4F4F5] border border-zinc-200"
              >
                <div className="w-12 h-12 bg-[#F0A500]/10 flex items-center justify-center mb-3">
                  <span className="text-lg font-black text-[#F0A500]">
                    {sponsor.name.charAt(0)}
                  </span>
                </div>
                {sponsor.url ? (
                  <a href={sponsor.url} target="_blank" rel="noopener noreferrer" className="text-sm font-bold text-[#0A0A0A] text-center leading-tight hover:text-[#F0A500] transition-colors">
                    {sponsor.name}
                  </a>
                ) : (
                  <p className="text-sm font-bold text-[#0A0A0A] text-center leading-tight">{sponsor.name}</p>
                )}
                <p className="text-xs text-[#52525B] text-center mt-2 leading-relaxed">{sponsor.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer message */}
      <section className="py-16 sm:py-24 bg-[#0A0A0A] text-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-4">
            Supporting Our Community
          </h2>
          <p className="text-base text-zinc-400 mb-4">
            All proceeds from the Round Table Bar go back into running Glossop Heritage Weekend 2028. The bar is run entirely by unpaid volunteers from Glossop & District Round Table and the local community.
          </p>
          <p className="text-sm text-zinc-500">
            Thank you for your support!
          </p>
        </div>
      </section>
    </div>
  );
}
